export default "__VITE_ASSET__DltEWYqS__"